export function main (_p5) {
  let p5
  p5 = _p5

  const num = 77
  let p = []
  const maxVelocity = 7.1
  const maxAcceleration = 0.2
  let parentDiv
  let parentWidth
  let parentHeight
  let canvas
  let radRange
  p5.setup = _ => {
    parentDiv = document.getElementById(
      'internalFluctuation-canvas-wrapper'
    )
    parentWidth = parentDiv.offsetWidth
    parentHeight = parentDiv.offsetHeight
    canvas = p5.createCanvas(parentWidth, parentHeight)
    canvas.parent('InternalFluctuation-canvas')

    radRange = parentWidth * 0.08
    for (let i = 0; i < num; i++) {
      const angle = (360 / num) * i
      p[i] = new Particle(
        radRange * p5.cos(p5.radians(angle)) + parentWidth / 2,
        radRange * p5.sin(p5.radians(angle)) + parentHeight / 2
      )
    }
    p5.frameRate()
    p5.background(240)
    p5.stroke(255, 82, 68)
    p5.noFill()
    p5.mouseX = p5.random(parentWidth)
    p5.mouseY = p5.random(parentHeight)
  }
  p5.windowResized = () => {
    p5.frameCount = 0
    p5.loop()
    p5.setup()
    p5.resizeCanvas(parentWidth, parentHeight)
  }
  p5.draw = () => {
    for (let i = 0; i < p.length; i++) {
      p[i].update(p5.mouse)
      p[i].show()
    }
    if (p5.frameCount > 1600) {
      p5.noLoop()
    }
  }

  class Particle {
    constructor (x, y) {
      this.pos = p5.createVector(x, y)
      this.vel = p5.createVector(0, 0)
      this.acc = p5.createVector(0, 0)
    }
    update () {
      // this.acc = p5.sub(p5.mouse, this.pos)
      this.acc.x = p5.mouseX - this.pos.x
      this.acc.y = p5.mouseY - this.pos.y

      this.acc.setMag(maxAcceleration)
      this.pos.add(this.vel)
      this.vel.add(this.acc)
      this.vel.limit(maxVelocity)
    }
    show () {
      p5.ellipse(this.pos.x, this.pos.y, 0.3)
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/InternalFluctuation.js